import { Directive, input } from '@angular/core';

@Directive({
  selector: '[uwTooltip]',
  standalone: true,
  host: {
    '[attr.data-uw-tooltip]': 'text()',
    '[attr.tabindex]': 'focusable() ? "0" : null',
  },
})
export class UwTooltip {
  readonly text = input.required<string>({ alias: 'uwTooltip' });
  readonly focusable = input(false);
}
